export const FACEBOOK_CUSTOM_AUDIENCE = "Facebook Custom Audience";
export const LIVE_RAMP = "LiveRamp";
export const MarketingCampaignTypes = [FACEBOOK_CUSTOM_AUDIENCE, LIVE_RAMP];

export const Reoccurrences = ["None", "Daily", "Weekly", "Monthly"];
